<template>
    <tinymce-editor v-model="html" @input="handlerFunction" model-events="change" :init="initSettings"></tinymce-editor>
</template>

<script>

    let InputField = require('@/mixins/InputField');

    export default {

        props: {
            value: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            height: {
                type: Number,
                required: false,
                default: 500,
            }
        },

        data() {
            return {
                html: this.value,
                initSettings: {
                    relative_urls: false,
                    remove_script_host: false,
                    convert_urls: false,
                    height: this.height,
                    plugins: [
                        'advlist autolink lists link  image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table contextmenu paste code help wordcount'
                    ],
                    toolbar: 'undo redo | copy paste | styleselect | bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | insertfile link media image | code fullscreen',
                    // tinydrive_token_provider: '/api/tinydrive',
                    // tinydrive_google_drive_key: 'YOUR_GOOGLE_DRIVE_KEY',
                    // tinydrive_google_drive_client_id: 'YOUR_GOOGLE_DRIVE_CLIENT_ID'
                }
            }
        },

        mounted() {
            $(document).on('focusin', event => {
                var target = $(event.target);
                if (target.closest(".mce-window").length || target.closest(".tox-dialog").length) {
                    event.stopImmediatePropagation();
                    target = null;
                }
            });
        },

        methods: {
            handlerFunction() {
                this.$emit('input', this.html);
            }
        },

        watch: {
            value() {
                this.html = this.value;
            }
        }
    }
</script>